<h1>Pacman</h1>
<div id="pacman"></div>
